/**
 * Sesami checkout lock â€” responds to custom events from the Sesami app:
 *   sesami:checkout:lock   â†’ disable storefront checkout entry points
 *   sesami:checkout:unlock â†’ re-enable them
 *
 * Events may be dispatched on window or document (bubbling or not). Both are
 * listened to so either pattern works.
 */
(function () {
  'use strict';

  if (window.__sesamiCheckoutLockInit) return;
  window.__sesamiCheckoutLockInit = true;

  var LOCK_ATTR = 'data-sesami-checkout-locked';
  var NATIVE_DISABLED_ATTR = 'data-sesami-checkout-disabled';
  var STYLE_ID = 'sesami-checkout-lock-styles';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var sel = 'html[' + LOCK_ATTR + '="true"] ';
    var css =
      sel +
      'button[name="checkout"],' +
      sel +
      'input[name="checkout"],' +
      sel +
      '[data-cc-checkout-button],' +
      sel +
      '[data-cart-checkout-buttons],' +
      sel +
      '[data-additional-checkout-button],' +
      sel +
      '.additional-checkout-buttons,' +
      sel +
      '.shopify-payment-button,' +
      sel +
      'fieldset[data-cart-checkout-button]{' +
      'pointer-events:none !important;opacity:.55;cursor:not-allowed !important;' +
      '}';
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = css;
    (document.head || document.documentElement).appendChild(el);
  }

  function isLocked() {
    return document.documentElement.getAttribute(LOCK_ATTR) === 'true';
  }

  /**
   * Same controls other Sesami integrations target: native cart checkout submits.
   * We only flip `disabled` where we set NATIVE_DISABLED_ATTR so we do not undo
   * theme/terms or other reasons a control was already disabled.
   */
  function syncNativeCheckoutSubmitButtons(locked) {
    var nodes = document.querySelectorAll(
      'input[name="checkout"], button[name="checkout"]'
    );
    var i;
    if (locked) {
      for (i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.hasAttribute(NATIVE_DISABLED_ATTR)) continue;
        if (el.disabled) continue;
        el.setAttribute(NATIVE_DISABLED_ATTR, '');
        el.disabled = true;
      }
    } else {
      var marked = document.querySelectorAll('[' + NATIVE_DISABLED_ATTR + ']');
      for (i = 0; i < marked.length; i++) {
        var btn = marked[i];
        btn.disabled = false;
        btn.removeAttribute(NATIVE_DISABLED_ATTR);
      }
    }
  }

  function applyLock(locked) {
    if (locked) {
      document.documentElement.setAttribute(LOCK_ATTR, 'true');
    } else {
      document.documentElement.removeAttribute(LOCK_ATTR);
    }
    syncNativeCheckoutSubmitButtons(locked);
  }

  function isCheckoutHref(href) {
    if (!href) return false;
    try {
      var u = new URL(href, window.location.origin);
      return u.pathname === '/checkout' || u.pathname.endsWith('/checkout');
    } catch (err) {
      return /\/checkout(\?|#|$)/.test(href);
    }
  }

  /**
   * True if this interaction should be blocked while locked (checkout / buy-it-now).
   */
  function isCheckoutInteraction(target) {
    if (!target || typeof target.closest !== 'function') return false;

    if (
      target.closest(
        'button[name="checkout"], input[name="checkout"], [data-cc-checkout-button]'
      )
    ) {
      return true;
    }
    if (target.closest('.shopify-payment-button')) return true;

    var link = target.closest('a[href]');
    if (link && isCheckoutHref(link.getAttribute('href'))) return true;

    if (target.closest('.additional-checkout-buttons, [data-additional-checkout-button]')) {
      return true;
    }

    return false;
  }

  function onClickCapture(e) {
    if (!isLocked()) return;
    if (!isCheckoutInteraction(e.target)) return;
    e.preventDefault();
    e.stopPropagation();
  }

  function onSubmitCapture(e) {
    if (!isLocked()) return;
    var sub = e.submitter;
    if (sub && sub.getAttribute && sub.getAttribute('name') === 'checkout') {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  function onSesamiLock() {
    applyLock(true);
  }

  function onSesamiUnlock() {
    applyLock(false);
  }

  function init() {
    injectStyles();

    document.addEventListener('click', onClickCapture, true);
    document.addEventListener('submit', onSubmitCapture, true);

    window.addEventListener('sesami:checkout:lock', onSesamiLock);
    window.addEventListener('sesami:checkout:unlock', onSesamiUnlock);
    document.addEventListener('sesami:checkout:lock', onSesamiLock);
    document.addEventListener('sesami:checkout:unlock', onSesamiUnlock);
  }

  init();
})();